import { css } from "@emotion/react";

const globalStyle = css`
  /* global */
  :root {
    font-size: 18px;
  }
  * {
    font-weight: 500;
  }
  div.dateOutter {
    min-width: 13rem;
  }

  /* ant design global */
  th.ant-table-cell {
    color: white !important;
  }
  a {
    text-decoration: none;
  }

  /* table */
  .bordered-table .ant-table-container {
    border-bottom: 1px black solid;
  }
  .bordered-table .ant-table-body > table,
  .bordered-table-no-white-border .ant-table-body > table {
    border-bottom: 1px black solid;
  }
  .bordered-table .ant-table-row .ant-table-cell,
  .bordered-table-no-white-border .ant-table-row .ant-table-cell {
    border-top: 1px black solid;
  }
  .bordered-table-blue .ant-table-body > table {
    border-bottom: 1px #3cb2c7 solid;
  }

  .bordered-table-no-white-border .ant-table-row .ant-table-cell {
    border-bottom: none;
  }

  .bordered-table-no-white-border td.ant-table-cell {
    border: none;
  }
`;

export default globalStyle;
